import { defineStore } from 'pinia'
import { fetchBanks } from './../api'
import { IBanksItem, ISortedBanks, IAlphabeticallySortedBank } from './types'
import { ref, computed, useContext } from '@nuxtjs/composition-api'
import { sortByField } from '@shared/utils'

export const useBanksModel = defineStore('banks', () => {
  const { $cookies } = useContext()

  const banks = ref<IBanksItem[]>([])
  const filteredBanks = ref<IBanksItem[]>([])

  // Часто используемые банки
  const banksFavorite = computed(() => {
    const banksPriority = banks.value.filter((i: IBanksItem) => i.priority)
    const sortable = []
    for (const priority in banksPriority) {
      sortable.push([priority, banksPriority[priority]])
    }
    sortable.sort(function (a: any, b: any) {
      return a[1] - b[1]
    })

    const objSorted: ISortedBanks = {}
    sortable.slice(0, 6).forEach(function (item: any) {
      objSorted[item[0]] = item[1]
    })
    return Object.values(objSorted)
  })

  // Отсортированный список по алфавиту
  const banksAlphabet = computed(() => {
    const alphabeticallySortedBanks = filteredBanks.value.reduce((acc: IAlphabeticallySortedBank[], bank) => {
      const letter = bank.name[0]
      const foundIndex: number = acc.findIndex(item => item.label === letter)

      if (foundIndex !== -1) {
        acc[foundIndex].banksInner.push(bank)
      } else {
        acc.push({ id: bank.id, label: letter, banksInner: [bank] })
      }
      return acc
    }, [])

    alphabeticallySortedBanks.sort(sortByField('label'))
    return alphabeticallySortedBanks
  })

  // Получить список всех банков
  async function fetchAllBanks () {
    const selectedBankID = $cookies.get('selectedBankID')
    const res = await fetchBanks()

    const selectedBank = res.find((i: IBanksItem) => i.id === +selectedBankID)

    if (selectedBank) {
      if (selectedBank.priority) {
        const resFilter = res.filter(i => i.name !== selectedBank.name)
        resFilter.unshift(selectedBank)

        banks.value = resFilter
        filteredBanks.value = resFilter
      } else {
        selectedBank.priority = 1
        res.unshift(selectedBank)

        banks.value = res
        filteredBanks.value = res
      }
    } else {
      banks.value = res
      filteredBanks.value = res
    }
  }

  // Сортировка банков
  function resortBanks () {
    const selectedBankID = $cookies.get('selectedBankID')
    const selectedBank = banks.value.find((i: IBanksItem) => i.id === +selectedBankID)
    const copyState: IBanksItem[] = JSON.parse(JSON.stringify(banks.value))

    if (!selectedBank) { return }
    const resFilter = copyState.filter(i => i.name !== selectedBank.name)
    resFilter.unshift(selectedBank)
    banks.value = resFilter
  }

  return {
    banks,
    banksFavorite,
    banksAlphabet,
    filteredBanks,
    fetchAllBanks,
    resortBanks
  }
})
